module.exports = __webpack_public_path__ + "static/img/ico-exerciseOut4-active.473d06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/ico-exerciseOut4-active.png
// module id = uqVN
// module chunks = 54